/**
 * hash 路由的跳转原语。
 *
 * 为什么单独成文件：`navigateHash` 原本是 TestApp 里的局部函数，而指南页
 * （`docs/mdx/NmnLive.tsx` 的「在编辑器中打开」）也需要它 —— 让组件去 import
 * 一个页面模块只为拿一个五行的函数，会把整条路由链拖进那份 chunk。
 *
 * ⚠️ 为什么要**手动派发** hashchange：给 `location.hash` 赋值本来就会触发一次
 *    `hashchange`，但那一次是异步的（排队到当前任务之后）。`setPendingDoc` → 跳转
 *    这条路径上，编辑器必须在同一个任务里看到新路由，否则会先按旧路由渲染一帧。
 *    主动派发一次让 React 当场同步更新，浏览器随后那一次是重复的 ——
 *    `parseHash()` 是纯函数，重复解析只是白算一次，不会有副作用。
 */
export function navigateHash(hash: string) {
	location.hash = hash
	window.dispatchEvent(new HashChangeEvent('hashchange'))
}
